// extracted by mini-css-extract-plugin
export default {"mCard":"Bt-z","image":"Ct-z","imageNoBackground":"Dt-z","fullWidth":"Et-z"};